var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBookingcar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 63.583,
    height: 52.229,
    viewBox: "0 0 63.583 52.229",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "_9229725711595988886_1_",
    "data-name": "9229725711595988886 (1)",
    d: "M61.042,23.167h2.271A2.145,2.145,0,0,0,65.583,20.9a2.145,2.145,0,0,0-2.271-2.271H56.954l-2.725-6.812A11.474,11.474,0,0,0,43.783,5H24.027a11.558,11.558,0,0,0-10.673,6.813L10.4,18.625H4.271A2.145,2.145,0,0,0,2,20.9a2.145,2.145,0,0,0,2.271,2.271H6.542A11.508,11.508,0,0,0,2,32.25v9.083a6.507,6.507,0,0,0,2.271,5v4.087a6.691,6.691,0,0,0,6.812,6.813h4.542a6.691,6.691,0,0,0,6.813-6.812V48.146H45.146v2.271a6.691,6.691,0,0,0,6.813,6.813H56.5a6.691,6.691,0,0,0,6.813-6.812V46.329a6.507,6.507,0,0,0,2.271-5V32.25A11.508,11.508,0,0,0,61.042,23.167ZM58.771,34.521A2.145,2.145,0,0,1,56.5,36.792H49.687a2.271,2.271,0,0,1,0-4.542H56.5A2.145,2.145,0,0,1,58.771,34.521ZM11.083,32.25H17.9a2.271,2.271,0,0,1,0,4.542H11.083a2.271,2.271,0,1,1,0-4.542ZM21.075,43.6,23.8,38.381a6.838,6.838,0,0,1,6.131-3.86h7.948a6.693,6.693,0,0,1,6.131,3.86L46.735,43.6ZM17.669,13.629A6.669,6.669,0,0,1,23.8,9.542H43.556a6.988,6.988,0,0,1,6.358,4.088L53.094,20.9H14.49Z",
    transform: "translate(-2 -5)",
    fill: "#02a5ec"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookingcar);
export default __webpack_public_path__ + "static/media/bookingcar.3bc1f8a53b91456bbc14dbac0cb59603.svg";
export { ForwardRef as ReactComponent };